<template>
  <v-app :style="backgroundStyle">
    <v-container fill-height>
      <v-layout align-center justify-center>
        <div style="text-align: center;">
          <h1>Welcome to Digital Candidate Concierge</h1>
          <p style="font-size: 21px; opacity: 0.6;">A bridge to the ultimate candidate<br/> interview experience</p>
          <v-btn class="login-btn" @click="loginTo" rounded outlined large min-width="200">
            <span>LOGIN</span>
            <v-icon style="padding-left: 10px;">mdi-login</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import AuthWrapper from "../../auth/authWrapper";

export default {
  data(){
    return{
      backgroundStyle:{ backgroundColor:"#ffffff" }
    }
  },
  mounted() {
    console.log("mounted index");
  },
  created () {
    this.$vuetify.theme.dark = false
  },
  methods: {
    loginTo() {
      AuthWrapper.service.login();
    }
  }
};
</script>

<style scoped>
.login-btn {
  color: #6D98AB;
  margin: 2%;
  font-size: 15px;
}
.login-btn:hover {
  background: #6D98AB !important;
  color: white;
}
@media only screen and (max-width: 1263px) {
  .border-between {
    border-left: none;
  }
}
</style>